module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 4H14V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v28c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM14 14v-2c0-1.1-.9-2-2-2H4V4h6v3a1 1 0 0 0 1 1h17v6H14z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/open-folder-1.js
// module id = 1319
// module chunks = 14